/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmContractSourceCodeInfo } from './EvmContractSourceCodeInfo';

export type KiteContractCodeInfo = {
    CNM: string;
    STS: KiteContractCodeInfo.STS;
    OPT: KiteContractCodeInfo.OPT;
    RUN: string;
    CV: string;
    EV: string;
    SCLIST: Array<EvmContractSourceCodeInfo>;
    ABI: string;
    CCC: string;
    DBC: string;
};

export namespace KiteContractCodeInfo {

    export enum STS {
        VERIFIED = 'VERIFIED',
    }

    export enum OPT {
        Y = 'Y',
        N = 'N',
    }


}

